export default __webpack_public_path__ + "static/media/preco.0479aa08.png";